import { render, staticRenderFns } from "./PointsTimelineItem.vue?vue&type=template&id=e21508fc&scoped=true&"
import script from "./PointsTimelineItem.vue?vue&type=script&lang=js&"
export * from "./PointsTimelineItem.vue?vue&type=script&lang=js&"
import style0 from "./PointsTimelineItem.vue?vue&type=style&index=0&id=e21508fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21508fc",
  null
  
)

export default component.exports